function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useProgressAnimation } from '../../hooks/useProgressAnimation';
export function InnerLine(props) {
  var percent = props.percent,
      className = props.className,
      _props$status = props.status,
      status = _props$status === void 0 ? 'normal' : _props$status,
      extra = _objectWithoutProperties(props, ["percent", "className", "status"]);

  var shape = 'inner-line';
  var cls = classnames(usePrefixCls('progress', {
    shape: shape
  }), className);
  var outerClas = usePrefixCls('progress-outer');
  var innerClas = usePrefixCls('progress-inner');
  var bgClas = usePrefixCls('progress-bg', {
    success: status === 'success',
    fail: status === 'exception'
  });
  var txtClas = usePrefixCls('progress-text');

  var style = _objectSpread({
    width: "".concat(percent, "%")
  }, useProgressAnimation(percent, false));

  return React.createElement("div", Object.assign({
    className: cls
  }, extra), React.createElement("div", {
    className: outerClas
  }, React.createElement("div", {
    className: innerClas
  }, React.createElement("div", {
    className: bgClas,
    style: style
  }, React.createElement("span", {
    key: 0,
    className: txtClas,
    title: "".concat(percent, "%")
  }, "".concat(percent, "%"))))));
}